import "./requests.css";
import Heading from "../heading/heading";
import BallsColor from "../ballsColor/ballsColor";
import GenericGrid from "../grid/grid";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  classificationsAprroverEng,
  getClassifications,
  getClassificationsId,
  getClassificationsMessage,
  getSessionReset,
  getSessionResetVerifyPn,
  getSessionVerifyPn,
} from "../../../redux/actions/fluxoNSimilar";
import { AppDispatch, RootState } from "../../../redux/store";
import { Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  GridColDef,
  GridSortDirection,
  GridSortModel,
} from "@mui/x-data-grid";
import { getCommonColumns } from "../../../utils/DataGrid/columnsCommon";
import { ButtonGeneric } from "../../ButtonGeneric/buttonGeneric";
import EyesButtonIcon from "../../../assets/svgs/eyesButtonIcon.svg";
import PlusButtonFilter from "../../../assets/svgs/plusButtonFilter.svg";
import NotificationIcon from "../../../assets/svgs/NotificationIcon.svg";
import EditButtonFilter from "../../../assets/svgs/editButtonFilter.svg";
import ClockButtonFilter from "../../../assets/svgs/clockButtonFilter.svg";
import asc from "../../../assets/svgs/asc.svg";
import desc from "../../../assets/svgs/desc.svg";
import Notification from "../../fluxo-tax/Notification/notification";
import SucessIcon from "../../../assets/svgs/sucess.svg";
import CheckButtonFilter from "../../../assets/svgs/checkButtonFilter.svg";
import IconXCircle from "../../../assets/svgs/icon-x-circle.svg";
import reloadButtonFilter from "../../../assets/svgs/reloadButtonFilter.svg";
import { getPnCode } from "../../../redux/slices/sessionSlice";
import { useRoles } from "../../../hooks/roles";
import ModalLog from "../modalLog/modalLog";
import iconabort from "../../../assets/svgs/abort.svg";
import usePersistedStateOnDemand from "../../../hooks/usePersistedStateOnDemand";
import { SkeletonWrapper } from "../../SkeletonWrapper/sleketonWrapper";
import ModalAprover from "../../fluxo-tax/modalAprover/modalAprover";
import Textnotifications from "../../../utils/notifications";
import functionDate from "../../../utils/formatarData";
import { CorrigirModal } from "../../corrigirModal/corrigirModal";
import InfoAlert from "../../alertComponent/alertUpdated";
import { loadFromStorage } from "../../../utils/storage";
import { showNotificationUtil } from "../../../utils/showNotificationUtil";
import { resolveSortByField } from "../../../utils/sortFieldMapper";
import Modal from "../../modal/modal";
import { ReactComponent as IconDownload } from "../../../assets/svgs/downloadBlue.svg";
import { useEngineerReportDownload } from "../../../hooks/useEngineerReportDownload";
import { usePersistedPagination } from "../../../hooks/usePersistedPagination";

const HOME_NOTIFICATION_KEY = "homeNotification";

export const Requests = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { page, setPage, pageSize, setPageSize, sortModel, setSortModel } =
    usePersistedPagination("pagination_requests", { page: 1, pageSize: 5 });
  const [filter, setFilter] = useState(false);
  const [totalPages, setTotalPages] = useState<number | undefined>(undefined);
  const [rows, setRows] = useState<any[]>([]);
  const [isBanner] = useState(false);
  const { isEngineer } = useRoles();
  const [loading, setLoading] = useState(false);
  const [description, setDescription] = useState("");
  const [, setIsRead] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalApproverEng, setModalApproverEng] = useState(false);
  const [modalCorrigir, setModalCorrigir] = useState(false);
  const [modalReset, setModalReset] = useState(false);
  const [corrigirText, setCorrigirText] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const selectedClassificationId: string | null = null;
  const selectedClassificationPn = "";
  const [labelNotification, SetLabelNotification] = useState("");
  const [notification, setNotification] = useState(false);
  const [backgroudError, setBackgroudError] = useState("");
  const [isDownloading, setIsDownloading] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const [classificationToReset, setClassificationToReset] = useState<{
    classificationId: string;
    partNumber: string;
    center: string;
  } | null>(null);

  // MATERIAL PART NUMBER
  const [materialPartNumber, setMaterialPartNumber, persistMaterialPartNumber] =
    usePersistedStateOnDemand<string>("materialPartNumber", "");

  // MATERIAL PART DESC
  const [materialPartDesc, setMaterialPartDesc, persistMaterialPartDesc] =
    usePersistedStateOnDemand<string>("materialPartDesc", "");

  // CENTER FILTER
  const [centerFilter, setCenterFilter, persistCenterFilter] =
    usePersistedStateOnDemand<string>("centerFilter", "");

  // EMITENTE
  const [emitentePartNumber, setEmitentePartNumber, persistEmitentePartNumber] =
    usePersistedStateOnDemand<string>("emitentePartNumber", "");

  // START DATE
  const [startDate, setStartDate, persistStartDate] =
    usePersistedStateOnDemand<string>("startDate", "");

  // END DATE
  const [endDate, setEndDate, persistEndDate] =
    usePersistedStateOnDemand<string>("endDate", "");

  const [
    classificationQuizStartDate,
    setClassificationQuizStartDate,
    persistClassificationQuizStartDate,
  ] = usePersistedStateOnDemand<string>("classificationQuizStartDate", "");

  const [
    classificationQuizFinishDate,
    setClassificationQuizFinishDate,
    persistClassificationQuizFinishDate,
  ] = usePersistedStateOnDemand<string>("classificationQuizFinishDate", "");

  const [
    classificationApprovalStartDate,
    setClassificationApprovalStartDate,
    persistClassificationApprovalStartDate,
  ] = usePersistedStateOnDemand<string>(
    "classificationApprovalStartDate",
    "",
  );

  const [
    classificationApprovalEndDate,
    setClassificationApprovalEndDate,
    persistClassificationApprovalEndDate,
  ] = usePersistedStateOnDemand<string>("classificationApprovalEndDate", "");

  const [selectedOptionsStatus, setSelectedOptionsStatus, persistStatus] =
    usePersistedStateOnDemand<{ status: string; label: string }[]>(
      "selectedStatus",
      [],
    );

  const [selectedOptionsCenter, setSelectedOptionsCenter, persistCenter] =
    usePersistedStateOnDemand<{ value: string; label: string }[]>(
      "selectedCenter",
      [],
    );

  const handleSortChange = (model: GridSortModel) => {
    setSortModel(model);
    setPage(1);
  };

  const sortModelGrid = (field: string) => {
    if (!isEngineer) return;

    const current = sortModel.find((item) => item.field === field);
    const nextSort: GridSortDirection =
      current?.sort === "asc" ? "desc" : "asc";

    setSortModel([{ field, sort: nextSort }]);
    setPage(1);
  };

  const { sessionClassifications } = useSelector(
    (state: RootState) => state.sessionClassifications,
  );

  const { basicUserInfo } = useSelector((state: any) => state.user);

  const isCurrentUserEmitter = (emitter: string | null) => {
    return basicUserInfo?.email === emitter;
  };

  const normalizeStatusForApi = (status: string) => {
    if (status === "FINALIZADO") {
      return "ENTREGUE_SAP,FINALIZADO";
    }
    return status;
  };

  const buildEngineerPayload = (
    formatStatus: string[],
    formatCenters: string[],
  ) => {
    return {
      status: formatStatus.join(","),
      productCode: materialPartNumber?.toString() ?? "",
      presentationName: materialPartDesc?.toString() ?? "",
      emitter: emitentePartNumber?.toString() ?? "",
      center: formatCenters.join(","),
      startDate,
      endDate,
      classificationQuizStartDate,
      classificationQuizFinishDate,
      classificationApprovalStartDate,
      classificationApprovalEndDate,
      page,
      size: pageSize,
      sortBy: resolveSortByField(sortField, "classificationCreateDate"),
      sortDirection: sort,
    };
  };

  const { download } = useEngineerReportDownload(
    setIsDownloading,
    setBackgroudError,
  );

  const scrollToTop = () => {
    if (containerRef.current?.scrollIntoView) {
      containerRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    } else if (typeof navigator !== "undefined" && /jsdom/i.test(navigator.userAgent)) {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    } else if (
      globalThis.window !== undefined &&
      typeof globalThis.window.scrollTo === "function"
    ) {
      try {
        globalThis.window.scrollTo({ top: 0, behavior: "smooth" });
      } catch {
        console.error("window.scrollTo is not supported in this environment.");
      }
    }
  };

  const handleDownload = useCallback(async () => {
    scrollToTop();
    setBackgroudError("#DCEEFF");
    SetLabelNotification("Aguarde, o relatório está sendo exportado.");
    setNotification(true);

    const result = await download();

    scrollToTop();

    if (result.success) {
      setBackgroudError("#B8EFC9");

      showNotificationUtil(
        "Relatório exportado com sucesso!",
        SetLabelNotification,
        setNotification,
      );
    } else if (result.message) {
      showNotificationUtil(
        result.message,
        SetLabelNotification,
        setNotification,
      );
    } else {
      setNotification(false);
    }
  }, [download]);

  const { sort = "desc", field: sortField = "classificationCreateDate" } =
    sortModel[0] || {};
  const handleFilter = async () => {
    persistStatus();
    persistCenter();
    persistMaterialPartNumber();
    persistMaterialPartDesc();
    persistCenterFilter();
    persistEmitentePartNumber();
    persistStartDate();
    persistEndDate();
    persistClassificationQuizStartDate();
    persistClassificationQuizFinishDate();
    persistClassificationApprovalStartDate();
    persistClassificationApprovalEndDate();

    if (!isEngineer) return;

    const formatStatus = selectedOptionsStatus.map((o) =>
      normalizeStatusForApi(o.status),
    );

    const formatCenters = selectedOptionsCenter.map((o) => {
      return o.value;
    });

    dispatch(
      getClassifications(buildEngineerPayload(formatStatus, formatCenters)),
    ).finally(() => setLoading(false));
  };

  const handleDisableButton = () => {
    setIsButtonDisabled(!corrigirText);
  };

  // helpers para criar botões de ação
  const createButton = (
    title: string,
    img: string,
    onClick?: () => void,
    disabled: boolean = false,
    extra?: React.ReactNode,
  ) => (
    <Tooltip title={title} key={title}>
      <div
        className="buttonActions"
        style={{ position: "relative", display: "inline-block" }}
      >
        <ButtonGeneric
          img={img}
          className="buttonImg"
          onClick={onClick}
          disabled={
            disabled ||
            (title !== "Visualizar Material" &&
              basicUserInfo.has_crea === false)
          }
        />
        {extra}
      </div>
    </Tooltip>
  );

  // botão de Visualizar
  const visualizarButton = (onClick: () => void, isRead?: boolean) =>
    createButton(
      "Visualizar Material",
      EyesButtonIcon,
      onClick,
      false,
      isRead === false ? (
        <img
          src={NotificationIcon}
          alt="Notificação"
          className="notificationImage"
        />
      ) : null,
    );

  const openResetModal = (
    classificationId: string,
    partNumber: string,
    center: string,
  ) => {
    setClassificationToReset({
      classificationId,
      partNumber,
      center,
    });
    setModalReset(true);
  };

  // botão genéricos para cada status
  const buttonsByStatus = (
    status: string,
    onVisualizar: () => void,
    onVerify: (pn: string, ct: string) => void,
    partNumber: string,
    center: string,
    emitter: string | null,
    isRead?: boolean,
    classificationId?: any,
  ) => {
    const resetEnabledStatuses = [
      "EM_CLASSIFICACAO",
      "PENDENTE_VALIDACAO_FISCAL",
      "EM_ANALISE",
    ];
    const isResetEnabled = resetEnabledStatuses.includes(status) && isCurrentUserEmitter(emitter);

    const resetButton = (
      <React.Fragment key="resetar">
        {createButton(
          "Resetar",
          reloadButtonFilter,
          isResetEnabled
            ? () => openResetModal(classificationId, partNumber, center)
            : undefined,
          !isResetEnabled,
        )}
      </React.Fragment>
    );

    switch (status) {
      case "RECLASSIFICAR":
      case "NOVO":
        return [
          <React.Fragment key="visualizar">
            {visualizarButton(onVisualizar)}
          </React.Fragment>,

          <React.Fragment key="iniciar">
            {createButton("Iniciar", PlusButtonFilter, () =>
              onVerify(partNumber, center),
            )}
          </React.Fragment>,

          resetButton,
        ];

      case "EM_CLASSIFICACAO":
        return [
          <React.Fragment key="visualizar">
            {visualizarButton(onVisualizar)}
          </React.Fragment>,

          <React.Fragment key="preencher">
            {createButton("Preencher", EditButtonFilter, () =>
              onVerify(partNumber, center), !isCurrentUserEmitter(emitter),
            )}
          </React.Fragment>,

          resetButton,
        ];

      case "PENDENTE_VALIDACAO_FISCAL":
        return [
          <React.Fragment key="visualizar">
            {visualizarButton(onVisualizar)}
          </React.Fragment>,

          <React.Fragment key="validando">
            {createButton("Validando", ClockButtonFilter, undefined, true)}
          </React.Fragment>,

          resetButton,
        ];

      case "EM_ANALISE":
        return [
          <React.Fragment key="visualizar">
            {visualizarButton(onVisualizar, isRead)}
          </React.Fragment>,

          <React.Fragment key="validando">
            {createButton("Validando", ClockButtonFilter, undefined, true)}
          </React.Fragment>,

          resetButton,
        ];

      case "ENTREGUE_SAP":
      case "FINALIZADO":
      case "RECLASSIFICADO":
        return [
          <React.Fragment key="visualizar">
            {visualizarButton(onVisualizar)}
          </React.Fragment>,

          <React.Fragment key="finalizado">
            {createButton(
              "Processo Finalizado",
              CheckButtonFilter,
              undefined,
              true,
            )}
          </React.Fragment>,

          resetButton,
        ];

      case "SUSPENSO":
        return [
          <React.Fragment key="visualizar">
            {visualizarButton(onVisualizar)}
          </React.Fragment>,

          <React.Fragment key="suspenso">
            {createButton("Suspenso", IconXCircle, undefined, true)}
          </React.Fragment>,

          resetButton,
        ];

      default:
        return [
          <React.Fragment key="visualizar">
            {visualizarButton(onVisualizar, isRead)}
          </React.Fragment>,

          resetButton,
        ];
    }
  };

  const columns: GridColDef[] = [
    {
      field: "classificationId",
      headerClassName: "header-table",
      renderHeader: (params) => (
        <b className="partNumberColluns"> classificationId </b>
      ),
      renderCell: (params) => (
        <p className="partNumberColluns"> {params.value} </p>
      ),
      flex: 2.0,
      headerAlign: "right",
      align: "right",
    },
    ...getCommonColumns({
      sortModel,
      onOpenDescription: (desc) => {
        setIsModalOpen(true);
        setDescription(desc);
      },
      ascIcon: asc,
      descIcon: desc,
      onTap: sortModelGrid,
    }),
    {
      field: "emitter",
      headerClassName: "header-table",
      renderHeader: () => <b className="emitenteColluns">Emitente</b>,
      renderCell: (params) => {
        const value = params.row.emitter ?? "";
        return value.length > 20 ? (
          <Tooltip title={value}>
            <div
              style={{
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {value.slice(0, 20) + "..."}
            </div>
          </Tooltip>
        ) : (
          <div
            style={{
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {value}
          </div>
        );
            },
      flex: 1.2,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "status",
      flex: 0.5,
      headerAlign: "center",
      align: "center",
      renderHeader: (params) => (
        <div className="descriptionText">
          <b className="title-table"> Status </b>
        </div>
      ),
      renderCell: (params) => {
        const status = params.row.status;
        let tooltipTitle = "";
        let backgroundColor = "";
        switch (status) {
          case "NOVO":
            tooltipTitle = "Novo";
            break;

          case "RECLASSIFICAR":
            tooltipTitle = "Reclassificar";
            break;

          case "EM_CLASSIFICACAO":
            tooltipTitle = "Em classificação";
            break;

          case "PENDENTE_VALIDACAO_FISCAL":
            tooltipTitle = "Pendente de Validação Fiscal";
            break;

          case "EM_ANALISE":
            tooltipTitle = "Em Análise";
            break;

          case "ENTREGUE_SAP":
          case "FINALIZADO":
            tooltipTitle = "Processo Finalizado";
            backgroundColor = "#00884A";
            break;

          case "RECLASSIFICADO":
            tooltipTitle = "Reclassificado";
            break;

          case "SUSPENSO":
            tooltipTitle = "Suspenso";
            break;
        }

        return (
          <Tooltip title={tooltipTitle} placement="right">
            <div className="status-forecast-text">
              <div
                className={`status-forecast ${
                  params.value &&
                  (isEngineer && params.value === "ENTREGUE_SAP"
                    ? "Processo Finalizado"
                    : params.value.toLowerCase())
                }`}
                style={{ backgroundColor: backgroundColor }}
              ></div>
            </div>
          </Tooltip>
        );
      },

      headerClassName: "header-table",
    },

    {
      field: "ações",
      flex: 0.85,
      headerAlign: "center",
      align: "center",
      renderHeader: (params) => <b className="title-table"> Ações </b>,
      renderCell: (params) => {
        const {
          status,
          partNumber,
          center,
          description,
          emitter,
          isRead,
          classificationId,
        } = params.row;

        const handleVisualizarMaterial = async () => {
          setLoading(true);
          await new Promise((resolve) => setTimeout(resolve, 1500));
          const result = await dispatch(
            getClassificationsId({ id: classificationId }),
          );

          if (getClassificationsId.fulfilled.match(result)) {
            localStorage.setItem("selectedEmiiter", emitter ?? "");
            setLoading(false);
            setIsRead(isRead);
            navigate(`/detalhes-material/${partNumber}?center=${center}`, {
              state: { read: isRead },
            });
            dispatch(getPnCode({ pnNumberCode: partNumber, description }));
          } else {
            console.error("Erro ao buscar classificação", result);
          }
        };

        const handleClickVerify = async (sessionId: string, center: string) => {
          await dispatch(
            getSessionVerifyPn({ pn: sessionId, ct: center }),
          ).unwrap();
          dispatch(getPnCode({ pnNumberCode: partNumber, description }));
          navigate("/emissao-laudo");
        };

        const actionButtons = buttonsByStatus(
          status,
          handleVisualizarMaterial,
          handleClickVerify,
          partNumber,
          center,
          emitter,
          isRead,
          classificationId,
        );

        return (
          <div
            style={{
              display: "flex",
              width: "100%",
              paddingTop: "15px",
              justifyContent: "flex-start",
              alignItems: "center",
              gap: "0px",
              flexWrap: "nowrap",
              overflowX: "auto",
            }}
          >
            {actionButtons.map((button) => (
              <div
                key={(button as React.ReactElement).key}
                style={{ display: "flex", alignItems: "center", flexShrink: 0 }}
              >
                {button}
              </div>
            ))}
          </div>
        );
      },

      headerClassName: "header-table",
    },
  ];

  const handleApprover = async () => {
    if (!selectedClassificationId) return;

    try {
      await dispatch(
        classificationsAprroverEng(selectedClassificationId),
      ).unwrap();

      setModalApproverEng(false);
      SetLabelNotification(
        Textnotifications.getAprovarSuccess(selectedClassificationPn),
      );
      handleFilter();
      setPage(1);
      setNotification(true);
      setBackgroudError("#B8EFC9");

      setTimeout(() => {
        setNotification(false);
      }, 5000);
    } catch (error: any) {
      console.log("error", error);
      if (error?.httpStatus === 422) {
        setModalApproverEng(false);
        setNotification(true);
        setBackgroudError("#FFD9D9");
        SetLabelNotification(
          "Para aprovar essa classificação é necessário o papel de aprovador de engenharia.",
        );

        setTimeout(() => {
          setNotification(false);
        }, 5000);
      } else {
        console.error("Erro ao aprovar laudo:", error);
      }
    }
  };

  const handleCorrigir = async () => {
    if (!selectedClassificationId) return;

    try {
      await dispatch(
        getClassificationsMessage({
          classificationId: selectedClassificationId,
          message: corrigirText,
          userRole: "TAX",
          origin: "JUSTIFICATIVA_ENG",
          ncmCode: "",
        }),
      ).unwrap();

      setNotification(true);
      SetLabelNotification(
        Textnotifications.getCorrigirSuccess(selectedClassificationPn),
      );
      setBackgroudError("#B8EFC9");
      setPage(1);
      setModalCorrigir(false);
      handleFilter();
      setCorrigirText("");
    } catch (error: any) {
      if (error?.httpStatus === 422) {
        setNotification(true);
        setBackgroudError("#FFD9D9");
        SetLabelNotification(
          "Para corrigir essa classificação é necessário o papel de aprovador de engenharia.",
        );
        setModalCorrigir(false);
      } else {
        console.error("Erro ao corrigir classificação:", error);
      }
    } finally {
      setTimeout(() => {
        setNotification(false);
      }, 5000);
    }
  };

  const handleReset = async () => {
    if (!classificationToReset) {
      setModalReset(false);
      return;
    }

    try {
      const verifyResult = await dispatch(
        getSessionResetVerifyPn({
          pn: classificationToReset.partNumber,
          ct: classificationToReset.center,
        }),
      ).unwrap();

      const sessionId = verifyResult?.message;

      if (!sessionId) {
        setModalReset(false);
        setBackgroudError("#FFD9D9");
        showNotificationUtil(
          functionDate.formatBodyText(
            Textnotifications.getResetError(classificationToReset.partNumber, true),
          ),
          SetLabelNotification,
          setNotification,
        );
        return;
      }

      await dispatch(getSessionReset(sessionId)).unwrap();

      const formatStatus = selectedOptionsStatus.map((o) =>
        normalizeStatusForApi(o.status),
      );

      const formatCenters = selectedOptionsCenter.map((o) => o.value);

      await dispatch(
        getClassifications(buildEngineerPayload(formatStatus, formatCenters)),
      );

      setModalReset(false);
      setBackgroudError("#B8EFC9");
      showNotificationUtil(
        functionDate.formatBodyText(
          Textnotifications.getResetSuccess(classificationToReset.partNumber),
        ),
        SetLabelNotification,
        setNotification,
      );
    } catch (error) {
      setModalReset(false);
      setBackgroudError("#FFD9D9");
      showNotificationUtil(
        functionDate.formatBodyText(
          Textnotifications.getResetError(classificationToReset.partNumber),
        ),
        SetLabelNotification,
        setNotification,
      );

      console.error("Erro ao resetar classificação:", error);
    }
  };

  useEffect(() => {
    setRows(sessionClassifications?.content ?? []);
    localStorage.removeItem("selectedEmiiter");
  }, [sessionClassifications]);

  useEffect(() => {
    if (!isEngineer) return;

    // STATUS
    const statusFromStorage = loadFromStorage<{ status: string }[]>(
      "selectedStatus",
      [],
    )
      .map((x) => normalizeStatusForApi(x.status))
      .join(",");

    const centerFromStorageS = loadFromStorage<{ value: string }[]>(
      "selectedCenter",
      [],
    )
      .map((x) => x.value)
      .join(",");

    // MATERIAL PART NUMBER
    const partNumberFromStorage = loadFromStorage<string>(
      "materialPartNumber",
      "",
    );

    const partDescFromStorage = loadFromStorage<string>("materialPartDesc", "");
    const emitterFromStorage = loadFromStorage<string>("emitentePartNumber", "");
    const startDateFromStorage = loadFromStorage<string>("startDate", "");
    const endDateFromStorage = loadFromStorage<string>("endDate", "");
    const classificationQuizStartDateFromStorage = loadFromStorage<string>(
      "classificationQuizStartDate",
      "",
    );
    const classificationQuizFinishDateFromStorage = loadFromStorage<string>(
      "classificationQuizFinishDate",
      "",
    );
    const classificationApprovalStartDateFromStorage = loadFromStorage<string>(
      "classificationApprovalStartDate",
      "",
    );
    const classificationApprovalEndDateFromStorage = loadFromStorage<string>(
      "classificationApprovalEndDate",
      "",
    );

    dispatch(
      getClassifications({
        status: statusFromStorage,
        productCode: partNumberFromStorage,
        presentationName: partDescFromStorage,
        emitter: emitterFromStorage,
        center: centerFromStorageS,
        startDate: startDateFromStorage,
        endDate: endDateFromStorage,
        classificationQuizStartDate: classificationQuizStartDateFromStorage,
        classificationQuizFinishDate: classificationQuizFinishDateFromStorage,
        classificationApprovalStartDate:
          classificationApprovalStartDateFromStorage,
        classificationApprovalEndDate: classificationApprovalEndDateFromStorage,
        page,
        size: pageSize,
        sortBy: resolveSortByField(sortField, "classificationCreateDate"),
        sortDirection: sort,
      }),
    );
  }, [page, pageSize, filter, dispatch, isEngineer, sort, sortField]);

  useEffect(() => {
    if (sessionClassifications) {
      setRows(sessionClassifications.content || []);
      setTotalPages(sessionClassifications.page?.totalPages ?? 1);
    }
  }, [sessionClassifications]);

  useEffect(() => {
    localStorage.removeItem("selectedCenter");
    localStorage.removeItem("selectedCenterForm");
  }, []);

  useEffect(() => {
    const homeNotification = localStorage.getItem(HOME_NOTIFICATION_KEY);

    if (!homeNotification) {
      return;
    }

    try {
      const parsedNotification = JSON.parse(homeNotification);

      if (parsedNotification?.message) {
        setBackgroudError(parsedNotification.backgroundError || "#B8EFC9");
        showNotificationUtil(
          parsedNotification.message,
          SetLabelNotification,
          setNotification,
        );
      }
    } catch (error) {
      console.error("Erro ao ler notificação da home:", error);
    } finally {
      localStorage.removeItem(HOME_NOTIFICATION_KEY);
    }
  }, []);

  return (
    <div ref={containerRef} style={{ height: "100%" }}>
      <SkeletonWrapper loading={loading} />

      {!loading && (
        <>
          <div className="containerHomePage">
            {notification && (
              <Notification
                label={labelNotification}
                backgroundError={backgroudError}
                setNotification={setNotification}
                img={SucessIcon}
              />
            )}
            <Heading
              titlePage="Relatório de Solicitações"
              buttonEmissao="sim"
              buttonDowload=""
              buttonVoltar=""
              filtros="sim"
              statusProps=""
              blockText="sim"
              detalsIA=""
              setMaterialPartNumber={setMaterialPartNumber}
              materialPartNumber={materialPartNumber}
              setMaterialPartDesc={setMaterialPartDesc}
              materialPartDesc={materialPartDesc}
              emitentePartNumber={emitentePartNumber}
              setEmitentePartDesc={setEmitentePartNumber}
              centerFilter={centerFilter}
              setCenterFilter={setCenterFilter}
              setStartDate={setStartDate}
              startDate={startDate}
              endDate={endDate}
              setEndDate={setEndDate}
              classificationQuizStartDate={classificationQuizStartDate}
              setClassificationQuizStartDate={setClassificationQuizStartDate}
              classificationQuizFinishDate={classificationQuizFinishDate}
              setClassificationQuizFinishDate={setClassificationQuizFinishDate}
              classificationApprovalStartDate={classificationApprovalStartDate}
              setClassificationApprovalStartDate={setClassificationApprovalStartDate}
              classificationApprovalEndDate={classificationApprovalEndDate}
              setClassificationApprovalEndDate={setClassificationApprovalEndDate}
              selectedOptionsCenter={selectedOptionsCenter}
              setSelectedOptionsCenter={setSelectedOptionsCenter}
              selectedOptionsStatus={selectedOptionsStatus}
              setSelectedOptionsStatus={setSelectedOptionsStatus}
              handleFilter={handleFilter}
              isBanner={isBanner}
              setPage={setPage}
              setPageSize={setPageSize}
              setFilter={setFilter}
            />
          </div>

          <div className="containerRequest">
            {basicUserInfo?.has_crea === false && (
              <div>
                <InfoAlert text="Criação de laudos indisponível. Peça associação a um aprovador ou solicite perfil de aprovador ao administrador." />
              </div>
            )}
            <div style={{ paddingBottom: "10px" }}>
              <span className="titleRequest">Processo de Solicitações</span>
            </div>
            <div className="containerBalls">
              <BallsColor titleStatus="Novo" colorStatus="#979EA4" />
              <BallsColor
                titleStatus="Em Classificação"
                colorStatus="#9DC9FF"
              />
              <BallsColor
                titleStatus="Pendente de Validação Fiscal"
                colorStatus="#A1DFDB"
              />
              <BallsColor titleStatus="Em Análise" colorStatus="#EEC100" />
              <BallsColor
                titleStatus="Processo Finalizado"
                colorStatus="#00884A"
              />
              <BallsColor titleStatus="Reclassificar" colorStatus="#9E2896" />
              <BallsColor titleStatus="Reclassificado" colorStatus="#FF9D9D" />
              <BallsColor titleStatus="Suspenso" colorStatus="#E8B6E3" />
            </div>
          </div>

            <div className="genericGrid" data-testid="generic-grid">
            <div className="exportBtn">
              <Tooltip title="Baixar relatório">
                <button
                  type="button"
                  onClick={handleDownload}
                  disabled={isDownloading}
                  aria-label="Baixar relatório"
                  className="iconButton"
                >
                  <IconDownload className="iconDownload" />
                </button>
              </Tooltip>
            </div>
            <GenericGrid
              rows={rows}
              totalPages={totalPages}
              page={page}
              columns={columns}
              setCurrentPage={setPage}
              totalElements={sessionClassifications?.page?.totalElements}
              setLoading={setLoading}
              sortModel={sortModel}
              handleSortChange={handleSortChange}
              setPage={setPage}
              enablePageSizeSelector={true}
              pageSize={pageSize}
              onPageSizeChange={(size) => {
                setPageSize(size);
                setPage(1);
              }}
            />
          </div>
          {isModalOpen && (
            <ModalLog
              className="ModalViewDescriptions modalContent"
              titleModalLog={"Descrição"}
              subTitleModalLog={description || ""}
              textModalLog={""}
              imgIcon={iconabort}
              onClose={() => setIsModalOpen(false)}
            />
          )}

          {modalApproverEng && (
            <ModalAprover
              titleModal="Aprovar Laudo Técnico"
              titleDescription={
                <div
                  style={{
                    marginBottom: 20,
                    marginTop: 15,
                  }}
                  className="titleAprover"
                  dangerouslySetInnerHTML={{
                    __html: functionDate.formatBodyText(
                      Textnotifications.getCorrigirBodyText(),
                    ),
                  }}
                />
              }
              bodyModal=""
              buttonOne="Confirmar"
              onConfirm={handleApprover}
              buttonTwo="Cancelar"
              onClose={() => setModalApproverEng(false)}
              isSubmitting={false}
            />
          )}

          {modalCorrigir && (
            <CorrigirModal
              open={modalCorrigir}
              onClose={() => {
                setModalCorrigir(false);
                setCorrigirText("");
              }}
              onConfirm={handleCorrigir}
              corrigirText={corrigirText}
              setCorrigirText={setCorrigirText}
              isButtonDisabled={isButtonDisabled}
              onDisableButton={handleDisableButton}
            />
          )}

          {modalReset && (
            <Modal
              titleDescription="Você deseja resetar a classificação?"
              titleModal="Aviso"
              bodyModal={
                <span className="resetModalBody">
                  Ao confirmar a ação, a classificação voltará para o status
                  "Novo" e o processo será reiniciado do zero.
                </span>
              }
              onClose={() => setModalReset(false)}
              onConfirm={handleReset}
              buttonOne="Resetar"
              buttonTwo="Cancelar"
              className="modalLogouts"
              isSubmitting={false}
            />
          )}
        </>
      )}
    </div>
  );
};

export default Requests;
